import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgNetworkIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    xmlSpace="preserve"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g className="network_svg__nc-icon-wrapper">
      <path
        data-color="color-2"
        d="M25 20h14a1 1 0 0 0 1-1c0-3.86-3.14-7-7-7h-2c-3.86 0-7 3.14-7 7a1 1 0 0 0 1 1z"
      />
      <circle data-color="color-2" cx={32} cy={6} r={4} />
      <path
        data-color="color-2"
        d="M17 28c0-3.86-3.14-7-7-7H8c-3.86 0-7 3.14-7 7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1z"
      />
      <circle data-color="color-2" cx={9} cy={15} r={4} />
      <path
        data-color="color-2"
        d="M57 21h-2c-3.86 0-7 3.14-7 7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1c0-3.86-3.14-7-7-7z"
      />
      <circle data-color="color-2" cx={56} cy={15} r={4} />
      <path d="M32 46c5.514 0 10-4.486 10-10s-4.486-10-10-10-10 4.486-10 10 4.486 10 10 10zM35 49h-6c-7.168 0-13 5.832-13 13a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1c0-7.168-5.832-13-13-13z" />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgNetworkStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgNetworkIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const NetworkIcon: any = SvgNetworkStyle;
export default NetworkIcon;
